import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnDestroy,
    OnInit,
    inject,
} from '@angular/core';
import { AzureUserService } from 'app/core/user/azure-user.service';
import { ApplicationUser } from 'app/core/user/user.types';
import { takeUntil } from 'rxjs';
import { BaseUserComponent } from './base-user.component';

@Component({
    selector: 'azure-user',
    templateUrl: './azure-user.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [...BaseUserComponent.imports],
})
export class AzureUserComponent
    extends BaseUserComponent
    implements OnInit, OnDestroy
{
    private _userService = inject(AzureUserService);

    @Input() showAvatar: boolean = true; // does not work from base component

    user: ApplicationUser;

    ngOnInit(): void {
        this.subscribeToUserChanges();
    }

    ngOnDestroy(): void {
        this.destroy();
    }

    subscribeToUserChanges(): void {
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user) => {
                this.user = user;

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    updateUserStatus(status: string): void {
        if (!this.user) {
            return;
        }

        // this._userService
        //     .updateAzureStatus({
        //         ...this.user,
        //         status,
        //     })
        //     .subscribe(() => {
        //         console.log('Azure user status updated.');
        //     });
    }
}
